export default __webpack_public_path__ + "static/media/code-alt.2acc6a58.svg";